import React from 'react'
import "./PackageDetail.css";
import { Link } from "react-router-dom";
import Header from '../components/Header';
import Footer from '../components/Footer';
import nabl from '../assets/images/nabl.png'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DoNotDisturbOnOutlinedIcon from '@mui/icons-material/DoNotDisturbOnOutlined';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import SentimentSatisfiedAltOutlinedIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import WhyTrust from '../layout/WhyTrust';

export default function PackageDetail() {
  return (
    <>
    <Header/>
    
        <div className="test_bredcum_sec">
            <div className="container-fluid">
                <div className="test_bredcum">
                   <Link to="/">Home</Link>
                    <span>&gt;</span>
                    <Link to="/">All Packages</Link>
                    <span>&gt;</span>
                    <span className='name_p'>Thyroid Assessment - Basic</span>
                </div> 
            </div> 
        </div>

        <div className="package_detail_main">
            <div className="container-fluid">
                <div className="inner_package_detail">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="package_detail_left">
                                <h3 className='heading_detail_test'>Tests Included (68)</h3>
                                <div className="test_name_filter main_details_package"> 
                                    <div className="accordion" id="accordionExample">
                                        <div className="accordion-item">
                                            <h2 className="accordion-header">
                                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                    Blood Studies (Anemia) (30)
                                                </button>
                                            </h2>
                                            <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                                <div className="accordion-body">
                                                   <div className="list_package_detail">
                                                      <h3>CBC Test (Complete Blood Count)</h3>   
                                                      <p>5 tests included</p>
                                                      <ul>
                                                         <li>HEMOGLOBIN</li>
                                                         <li>PCV</li>
                                                         <li>RBC COUNT</li>
                                                         <li>MCV</li>
                                                         <li>MCH</li>
                                                         <li>MCHC</li>
                                                         <li>R.D.W*</li>
                                                         <li>TOTAL LEUCOCYTE COUNT (TLC)</li>
                                                         <li>DIFFERENTIAL LEUCOCYTIC COUNT (DLC)</li>
                                                         <li>NEUTROPHILS*</li>
                                                         <li>LYMPHOCYTES*</li>
                                                         <li>EOSINOPHILS*</li>
                                                         <li>MONOCYTES*</li>
                                                         <li>BASOPHILS*</li>
                                                         <li>BLASTS*</li>
                                                         <li>PRO-MYELOCYTES*</li>
                                                         <li>MYELOCYTES*</li>
                                                         <li>META-MYELOCYTE*</li>
                                                         <li>BANDS*</li>
                                                         <li>BANDS*</li>
                                                         <li>ATYPICAL CELLS*</li>
                                                         <li>NRBC s/100 WBC*</li>
                                                         <li>CORRECTED TLC*</li>
                                                      </ul>
                                                    </div>                                  
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                     <div className="accordion" id="accordionExample">
                                        <div className="accordion-item">
                                            <h2 className="accordion-header">
                                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapsetwo" aria-expanded="true" aria-controls="collapsetwo">
                                                   Thyroid (3)
                                                </button>
                                            </h2>
                                            <div id="collapsetwo" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                                <div className="accordion-body">
                                                   <div className="list_package_detail">
                                                      <h3>CBC Test (Complete Blood Count)</h3>   
                                                      <p>5 tests included</p>
                                                      <ul>
                                                         <li>HEMOGLOBIN</li>
                                                         <li>PCV</li>
                                                         <li>RBC COUNT</li>
                                                         <li>MCV</li>
                                                         <li>MCH</li>
                                                         <li>MCHC</li>
                                                         <li>R.D.W*</li>
                                                         <li>TOTAL LEUCOCYTE COUNT (TLC)</li>
                                                         <li>DIFFERENTIAL LEUCOCYTIC COUNT (DLC)</li>
                                                         <li>NEUTROPHILS*</li>
                                                         <li>LYMPHOCYTES*</li>
                                                         <li>EOSINOPHILS*</li>
                                                         <li>MONOCYTES*</li>
                                                         <li>BASOPHILS*</li>
                                                         <li>BLASTS*</li>
                                                         <li>PRO-MYELOCYTES*</li>
                                                         <li>MYELOCYTES*</li>
                                                         <li>META-MYELOCYTE*</li>
                                                         <li>BANDS*</li>
                                                         <li>BANDS*</li>
                                                         <li>ATYPICAL CELLS*</li>
                                                         <li>NRBC s/100 WBC*</li>
                                                         <li>CORRECTED TLC*</li>
                                                      </ul>
                                                    </div>                                  
                                                </div>
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </div>

                            <div className="table_in_packagedetail">
                                <h5>Thyroid Assessment - Basic</h5>
                                <p>Test Overview</p>
                                <div className="main_table_detailpg">
                                    <table className="table table-bordered custom-table"> 
                                        <tbody>
                                            <tr>
                                                <td className="table_data">Sample Type</td>
                                                <td>Blood</td> 
                                            </tr>
                                            <tr>
                                                <td className="table_data">Report Delivery</td>
                                                <td>Earliest reports in 10-12 hours</td> 
                                            </tr>
                                            <tr>
                                                <td className="table_data">Price/Cost</td>
                                                <td>Rs 999</td> 
                                            </tr>
                                            <tr>
                                                <td className="table_data">Number of Tests Included</td>
                                                <td>33</td> 
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="faq_in_packagedetail">
                                 <div className="faq_innner">
                                    <h2 className="faq_heading_detail">Frequently Asked Questions (FAQs)</h2>

                                    <div className="accordion" id="accordionExample">
                                        <div className="accordion-item">
                                            <h2 className="accordion-header">
                                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                What services does CaresAtHome provide?
                                            </button>
                                            </h2>
                                            <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                            <div className="accordion-body">
                                                We provide nursing care, physiotherapy, bedside attendants, ICU setup, doctor consultations, diagnostics, emergency services, and medical equipment support.
                                            </div>
                                            </div>
                                        </div>

                                        <div className="accordion-item">
                                            <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                Can I book healthcare services at home?
                                            </button>
                                            </h2>
                                            <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                            <div className="accordion-body">
                                                We provide nursing care, physiotherapy, bedside attendants, ICU setup, doctor consultations, diagnostics, emergency services, and medical equipment support.                        </div>
                                            </div>
                                        </div>

                                        <div className="accordion-item">
                                            <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                Are your caregivers and nurses verified?
                                            </button>
                                            </h2>
                                            <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                            <div className="accordion-body">
                                                We provide nursing care, physiotherapy, bedside attendants, ICU setup, doctor consultations, diagnostics, emergency services, and medical equipment support.
                                            </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5">
                          <div className="for_sticky_section">
                             <div className="package_detail_right">
                                <div className="package_detail_right_first">
                                    <img src={nabl} alt="package-detail-icon" />
                                    <div className="content_pdrf">
                                        <h5>Thyroid Assessment - Basic</h5>
                                        <p>Also Known as Thyroid Package</p>
                                        <ul className='pdrf_list_sec'>
                                            <li><DescriptionOutlinedIcon /> Earliest reports in 10-12 hours</li>
                                            <li><DoNotDisturbOnOutlinedIcon /> No preparation required</li>
                                        </ul>
                                    </div>
                                    <div className="btn_and_prices_pdr">
                                        <div class="price_and_offer"><h5>₹699 <span class="off_price_pakages">(₹999)</span></h5><span class="offer_pakages">25% Off</span></div>
                                        <div class="package_box_btns"> <div class="package_detail_right_btn pf_btn-n">  <Link to="/bookingform">Book Now</Link> </div> <div class="package_detail_right_btn puf_btn-n"> <a href="#">Add to Cart</a> </div> </div>
                                    </div>
                                </div>
                            </div>
                            <div className="contact_number_pd">
                                <div className="icon_number_pd">
                                    <PhoneInTalkIcon/>
                                </div>
                                <div className="number_pd">
                                    <p>Need Help? </p>
                                    <a href="tel:+919521111603">+91-9521111603</a>
                                </div>
                            </div>
                            <div className="why_choose_pd">
                                <h5>Why Choose Cares At Home?</h5>
                                <ul className='why_us_pd'>
                                    <li><GppGoodOutlinedIcon/> NABL Certified Labs</li>
                                    <li><SentimentSatisfiedAltOutlinedIcon/> 10,000+ Happy Customers</li>
                                    <li><MedicalServicesIcon/> Trusted By Doctors</li>
                                    <li><HealthAndSafetyOutlinedIcon/> Safe & Hygienic Collection</li>
                                    <li><PendingActionsOutlinedIcon/> On-time Reports</li>
                                </ul>
                            </div>
                          </div> 
                        </div>
                    </div>
                </div>
            </div>

            <WhyTrust/>
        </div>
    
    
    <Footer/>
    </>
  )
}
